module.exports = __webpack_public_path__ + "img/unstabilized_unstabilized.c150479f.png";